/**
 * 基础使用
 */
import { failToast, successToast } from '@/common/utils/toast'
import { Button, FormPro, Icon, Input  } from '@roo/roo'
import Loading from '@roo/roo/Loading'
import React, { useState } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import { ssoLogin, userLogin } from './api'
import { getHashQuery, onFormCheckFail } from '@/common/utils'
import { Link, useNavigate } from 'react-router-dom'
import { encryptPsw } from './utils'
import useUpdateUser from '@/common/recoil/atom/userAtom'
import Home from '../home'
import qs from 'qs'
import { useRequest } from 'ahooks'
import entFunctionConfigAtom from '@/common/recoil/atom/entFunctionConfigAtom'
import PageBox from '@/components/PageBox'
import EmailSvg from '@/components/Icons/EmailSvg'
import PswIcon from '../password/components/PswIcon'
import entInfoAtom from '@/common/recoil/atom/entInfoAtom'
import aggregateQueryAtom from '@/common/recoil/atom/aggregateQuery'


const UserLogin: React.FC = () => {
  const { t } = useTranslation()
  const updateUserInfo = useUpdateUser()
  const updateEntInfo = entInfoAtom.useRefresh()
  const updateAggregateQueryInfo = aggregateQueryAtom.useRefresh()
  const navigate = useNavigate()
  const { mis,  name,  entId,  timeStamp } = qs.parse(window.location.hash.split('?')[1], { decoder: (str) => str }) as {[k:string]: string} // NOTE: 必须有decoder,防止参数被解析
  const isSSO = mis && name && entId && timeStamp
  const refreshEntFunctions = entFunctionConfigAtom.useRefresh()

  const { loading: ssoLoading, error: ssoError } = useRequest(ssoLogin, { // sso登录并跳转
    ready: Boolean(isSSO),
    defaultParams: [{ mis, name, entId, timeStamp }],
    onSuccess: afterLogin,
  })

  const { loading: submitLoading, run: handleSubmit } = useRequest(async (values: any) => { // 用户手动登录
    const psw = await encryptPsw(values.password) as string
    await userLogin({ userName: values.account, password: psw })
    afterLogin()
  }, {
    manual: true,
  })


  function afterLogin () {
    successToast(t('e_pc_welcome_back', 'Welcome back'))
    const backpath = decodeURIComponent(getHashQuery().backpath || '/')
    updateUserInfo()
    updateEntInfo()
    refreshEntFunctions()
    updateAggregateQueryInfo()
    navigate(backpath.startsWith('/') ? backpath : '/', { replace: true })
  }

  if (isSSO && !ssoError) { // sso登录,展示欢迎页
    return (
      <div>
        {ssoLoading && <Loading />}
        <Home />
      </div>
    )
  }

  return (
    <PageBox >
      <div >
        <h2 style={{  margin: 0, paddingBottom: '20px', textAlign: 'center' }}>{t('e_pc_welcome_ent', '欢迎使用Keeta企业版')}</h2>
        <FormPro
          name="basic"
          initialValues={{ remember: true }}
          onFinish={handleSubmit}
          onFinishFailed={onFormCheckFail}
          colon={false}
          wrapperCol={{ span: 12 }}
          style={{ minWidth: '280px' }}
        >
          <FormPro.Item
            name="account"
            validateTrigger={['onBlur']}
            rules={[{ required: true, message: t('e_pc_enter_email', '请输入电子邮箱账户'), type: 'email' }]}

          >
            <Input type="text" placeholder={t('e_pc_enter_email', '请输入电子邮箱账户')}  prefix={<div style={{ marginBottom: '-6px' }}><EmailSvg /></div>}/>
          </FormPro.Item>

          <FormPro.Item
            name="password"
            rules={[{ required: true, message: t('e_pc_enter_pwd', '请输入密码') }]}
          >

            <Input placeholder={t('e_pc_enter_pwd', '请输入密码')} type="password"
              prefix={<PswIcon />}
            />
          </FormPro.Item>
          <div style={{ marginBottom: '12px', marginTop: '-12px', width: '100%', display: 'flex', 'justifyContent': 'flex-end' }}>
            <Link to="/password/forget">{t('e_pc_forgot_password', '忘记密码?')}</Link>
          </div>
          <FormPro.Item>
            <Button type="brand" htmlType="submit" style={{ width: '100%' }} loading={submitLoading}>
              {t('e_pc_user_login', '用户登录')}
            </Button>
          </FormPro.Item>
        </FormPro>
      </div>
    </PageBox>
  )
}


export default UserLogin